import React from 'react';
import { useTranslation } from "react-i18next";
import { ModalDialog, ComponentL, Size } from "@laerdal/life-react-components";

interface LicenseRevocationModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const LicenseRevocationModal: React.FC<LicenseRevocationModalProps> = ({
    isOpen,
    onClose
}) => {
    const { t } = useTranslation("cases");

    return (
        <ModalDialog
            closeModalAndClearInput={onClose}
            title="Unable to revoke your license"
            size={Size.Large}
            isModalOpen={isOpen}
            closeAction={onClose}
            submitAction={() => { }}
            buttons={[
                {
                    action: onClose,
                    text: 'Okay',
                },
            ]}
        >
            <>
                <ComponentL>{t('Dear Customer,')}</ComponentL>
                <br/>
                <ComponentL>{t('Thank you for reaching out. Unfortunately, we are unable to revoke your license through this channel. Please contact your ITC for support.')}</ComponentL>
                <br/>
                <ComponentL>{t('Please note that your license has already been invoiced.')}</ComponentL>
                <br/>
                <ComponentL>{t('Best regards,')}</ComponentL>
                <ComponentL>{t('Your Laerdal RQI Team')}</ComponentL>
            </>
        </ModalDialog>
    );
};
